export default __webpack_public_path__ + "static/IN-9408-vs-IN-9008_resTestBig2-464acf7b26c09e7746bdfd9ab3a2d201.webp";